import { render, staticRenderFns } from "./BaseScroll.vue?vue&type=template&id=410e715c&scoped=true&"
import script from "./BaseScroll.vue?vue&type=script&lang=js&"
export * from "./BaseScroll.vue?vue&type=script&lang=js&"
import style0 from "./BaseScroll.vue?vue&type=style&index=0&id=410e715c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410e715c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('410e715c', component.options)
    } else {
      api.reload('410e715c', component.options)
    }
    module.hot.accept("./BaseScroll.vue?vue&type=template&id=410e715c&scoped=true&", function () {
      api.rerender('410e715c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/base_components/BaseScroll.vue"
export default component.exports